import { render, staticRenderFns } from "./PaHeadingImage.vue?vue&type=template&id=484c307f&"
import script from "./PaHeadingImage.vue?vue&type=script&lang=js&"
export * from "./PaHeadingImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports